module.exports = __webpack_public_path__ + "static/media/icon_location_on.fe879838.svg";